import React , {useState} from 'react';
import {Cookies}  from '../js/localStorageCode';
import { NameValueModal ,TrackNewExpenseModal} from './Modals';
const environment = document.location.hostname.match(/meekmeek/) ? 'PROD' : document.location.hostname.match(/vercel/) ? 'PREVIEW': 'DEV';
const Expenses: React.FC = () => {
    const [selectedKey, setSelectedKey] = useState<string>('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isNewTrackingModalOpen, setIsNewTrackingModalOpen] = useState<boolean>(false);
    document.title = environment+":Expenses Page";
    const cookies = new Cookies();
    let allData = cookies.getAll();
    const keyList = Object.keys(allData).filter(key => key.match(/^TRACK/));

    const trackExpense = (expense:string, details:string) => {
      if(expense && expense.trim().length > 0 && details && details.trim().length > 0){
        const name = 'TRACK_EXPENSE-'+ expense + '-'+ details+ '-'+new Date().toISOString().split('.')[0]
        cookies.set(name, {nameofExpense:expense, detailsForExpense:details}, {expires: 365});
        allData = cookies.getAll();
      }
    }

    const handleSelect = (key: string) => {
      setSelectedKey(key);
      setIsModalOpen(true);
  };

  return (
    <div className="home">
    
      <h1>Create Expense Category</h1>
      <p>This is the "Create an Expense category" page so you can create one for later reference</p>
      <button onClick={()=>setIsNewTrackingModalOpen(true)}>Track Expense - New Category</button>
      {keyList.length === 0 && <h3>No Expense Categories have been created yet.</h3>}
      {!isModalOpen && keyList.length > 0 &&(
        <>
          <h1>Created Expense List</h1>
          <ul className="clickable-list">
              {keyList.map((key) => key.match(/^TRACK/) && (
                <li
                  key={key}
                  className={`list-item ${selectedKey === key ? 'selected' : ''}`}
                  onClick={() => handleSelect(key)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && handleSelect(key)}
                >
                  {key}
                </li>
              ))}
            </ul>
          </>
        )}
        {isModalOpen && (
          <NameValueModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            data={allData}
            keyValue={selectedKey}
          />
        )}
        {isNewTrackingModalOpen && (
          <TrackNewExpenseModal
            onClose={() => setIsNewTrackingModalOpen(false)}
            isOpen={isNewTrackingModalOpen}
            onSubmit={(expense:string, details:string) => {
              setIsNewTrackingModalOpen(false);
              trackExpense(expense, details) 
            }}
          />
            )}
          </div>
  );
};

export default Expenses;